export const ADDRESS_GET = "@common/ADDRESS_GET";
export const ADDRESS_GETCEPCIDADE = "@common/ADDRESS_GETCEPCIDADE";
export const ADDRESS_SET = "@common/ADDRESS_SET";
export const ADDRESS_RESET = "@common/ADDRESS_RESET";